import React from 'react';
export function Footer() {
  return <footer className="bg-neutral-950 border-t border-neutral-900 py-12 px-4 text-center mt-12" data-id="element-91">
      <div className="max-w-4xl mx-auto" data-id="element-92">
        <div className="text-xl font-bold text-white mb-4" data-id="element-93">
          💪 KIT LIBERA TU MENTE™
        </div>
        <p className="text-neutral-400 mb-8 max-w-md mx-auto" data-id="element-94">
          El sistema de claridad mental N°1 para profesionales saturados en
          España.
          <br data-id="element-95" />
          <br data-id="element-96" />
          Porque tener una mente clara no debería costarte todos los domingos
          del año.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-sm text-neutral-500 mb-8" data-id="element-97">
          <span data-id="element-98">📧 digipromarket3@gmail.com</span>
          <span className="hidden md:inline" data-id="element-99">·</span>
          <span data-id="element-100">📲 @digi.promarket</span>
        </div>

        <div className="text-xs text-neutral-600 mb-8" data-id="element-101">
          © Kit Libera Tu Mente™ 2026 — Todos los derechos reservados.
          Prohibida la reproducción y redistribución sin autorización expresa.
        </div>

        <div className="text-brand-accent/80 font-medium italic" data-id="element-102">
          💪 "La próxima semana puede ser la más clara que hayas tenido."
        </div>
      </div>
    </footer>;
}